import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sign-in"
export default class extends Controller {
   static targets = ["levelOne", "levelTwo", "orgCode"]
  connect() {
    console.log("connected to sign in controller")
  }

 submit() {
    this.orgCodeTarget.value =
      this.levelOneTarget.value + "-" + this.levelTwoTarget.value
  }
}
